var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isLoading)?_c('todos-toggle',{attrs:{"item-id":_vm.workItemId,"current-user-todos":_vm.currentUserTodos},on:{"todos-updated":_vm.updateCache,"error":function($event){return _vm.$emit('error', $event)}}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }